import { render, staticRenderFns } from "./OrderRegisters.vue?vue&type=template&id=243fc76f&"
import script from "./OrderRegisters.vue?vue&type=script&lang=js&"
export * from "./OrderRegisters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports